import map from 'lodash/map';
import apiRoutes from '../../../app/api/routes';

export const createOrganisationsUrl = (sort, page, pageSize, filters) => {
  const url = apiRoutes.getOrganisations();
  let filterString = '';

  if (filters !== null && filters !== {}) {
    map(filters, (filter, i) => {
      if (i !== '' && filter !== '') {
        filterString += `${i}=${filter}&`;
      }
    });
  }
  let queryString = '';
  if (sort !== undefined || page !== undefined || pageSize !== undefined || filterString !== '') {
    queryString += '?';

    if (sort !== undefined) {
      queryString += `sort=${sort}&`;
    }

    if (pageSize !== undefined) {
      queryString += `pageSize=${pageSize}&`;
    }

    if (page !== undefined) {
      queryString += `page=${page}&`;
    }

    if (filters !== null) {
      queryString += filterString;
    }
  }

  return url + queryString;
};
